export enum ContentFields {
  contentId = "contentId",

  name = "name",
  relevance = "relevance",

  authors = "authors",

  createdAt = "createdAt",
  updatedAt = "updatedAt",
}
